//import Libraries
import React, {Component} from 'react';
import { SMController, SMScene } from 'react-scrollmagic';

import { storageRef } from '../../../../firebase';

//import Components

//import Style classes

class ScrollCard extends Component{
    constructor(props) {
        super(props);
        this.state = {
            url : ''
        }
    }

    componentDidMount() {
        this.loadImageFromStorage();
    }

    loadImageFromStorage = () => {
        this.setState({
            url : ''
        })
        storageRef.child(`main_images/${this.props.text.id}.jpg`).getDownloadURL()
            .then((url) => {
                this.setState((prevState) => ({
                    url
                }))
            })
            .catch(e => {
            })
    }

    render() {
        return (
            <SMController>
                <SMScene
                        // indicators
                        triggerElement={"#card-"+this.props.cardNumber}
                        // triggerHook={0.8}
                        offset={-300}
                        // duration={window.innerHeight*2}
                        classToggle={"visible"}
                        reverse={false}>
                    <div 
                        id={"card-"+this.props.cardNumber} 
                        key={"card-"+this.props.cardNumber} 
                        className="ScrollCard">
                        <div className="CardText">
                            <div>
                                <h1>{this.props.text.title[this.props.universal.language]}</h1>
                                <p>{this.props.text.content[this.props.universal.language]}</p>
                            </div>
                        </div>
                        <div className="CardImage">
                            <img src={this.state.url} alt=""/>
                        </div>
                    </div>
                </SMScene>
            </SMController>
        );
    }
}

export default ScrollCard;


// WEBPACK FOOTER //
// ./src/pages/Home/ScrollSection/ScrollCards/ScrollCard.js